import { PlusIcon } from '@langchain/untitled-ui-icons';

import { Dispatch, SetStateAction, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Popover, PopoverContent, PopoverTrigger } from '@/components/Popover';
import { Button } from '@/design-system';

import { DatasetSessionCompareSelectorPopoverContent } from '../DatasetSessionCompareSelectorPopoverContent';
import { TextDisplayMode } from '../constants';
import { COMPARE_EXPERIMENT_TAB_SEARCH_PARAM_PREFIX } from './CompareExperimentTabs/constants';

export const DatasetSessionCompareAddExperimentPopover = ({
  sessionIds,
  datasetShareToken,
  datasetName,
  setAddedSessions,
  setTextDisplayMode,
  textDisplayMode,
  disabled,
}: {
  sessionIds: string[];
  datasetShareToken?: string;
  datasetName: string;
  setAddedSessions?: Dispatch<SetStateAction<string[]>>;
  setTextDisplayMode: (textDisplayMode: TextDisplayMode) => void;
  textDisplayMode: TextDisplayMode;
  disabled?: boolean;
}) => {
  const [, setSearchParams] = useSearchParams();

  const [popoverOpen, setPopoverOpen] = useState(false);

  return (
    <Popover open={popoverOpen} onOpenChange={setPopoverOpen}>
      <PopoverTrigger asChild>
        <Button leftDecorator={PlusIcon} disabled={disabled} size="md">
          Compare
        </Button>
      </PopoverTrigger>
      <PopoverContent sideOffset={5} align="end" className="w-[508px] p-0">
        <DatasetSessionCompareSelectorPopoverContent
          selectedSessionIds={sessionIds}
          onlyAdd={false}
          handleSelectOrUnselectSession={(
            sessionId: string,
            shouldSelect: boolean
          ) => {
            setAddedSessions?.((prev) =>
              shouldSelect
                ? [...prev, sessionId]
                : prev.filter((id) => id !== sessionId)
            );
            const newParams = sessionIds;
            if (shouldSelect) {
              newParams.push(sessionId);
            } else {
              newParams.splice(sessionIds.indexOf(sessionId), 1);
            }
            // if there is more than 1 session id then set diff to false
            if (
              newParams.length > 1 &&
              textDisplayMode === TextDisplayMode.DIFF
            ) {
              setTextDisplayMode(TextDisplayMode.FULL);
            }
            setSearchParams(
              (prev) => {
                if (!newParams.length) {
                  prev.delete(
                    `${COMPARE_EXPERIMENT_TAB_SEARCH_PARAM_PREFIX}tab`
                  );
                }
                prev.set('selectedSessions', newParams.join(','));
                return prev;
              },
              { replace: true }
            );
          }}
          datasetShareToken={datasetShareToken}
          datasetName={datasetName}
          emptyStateString="All experiments already shown"
        />
      </PopoverContent>
    </Popover>
  );
};
